﻿import { Directive } from "@app/components/directive";
import { NgComponent } from "@app/di/decorators";
import { Token } from "@app/di/token";

@NgComponent({
    token: Token.KbAllowFraction,
    dependencies: [
        Token.$Q,
        Token.$Http,
    ]
})
export class KbAllowFractions extends Directive {
    constructor() {
        super();
        this.restrict = "A";
        this.require = "ngModel";
            
        this.link = (scope, elem, attr, ctrl) => {
            let maxValidator = value => {
                let allowFractions = scope.$eval(attr.kbAllowFractions) || true;
                if (!allowFractions && value % 1 != 0) {
                    let newValue = Math.round(value);
                    $(elem).val(newValue);
                    return newValue;
                }
                return value;
            };

            ctrl.$parsers.push(maxValidator);
            ctrl.$formatters.push(maxValidator);
        };
    }
}
